import React, { useEffect, useState } from "react";
import Modal from "@material-ui/core/Modal";
import Paper from "@material-ui/core/Paper";
import {
  CircularProgress,
  Grid,
  makeStyles,
  MenuItem,
  TextField,
  Typography,
} from "@material-ui/core";
import { InputButton } from "../../../../../components/input-button/InputButton";
import { FormattedMessage, useIntl } from "react-intl";
import Alert from "@material-ui/lab/Alert";
import { FormikHelpers, useFormik } from "formik";
import * as Yup from "yup";
import { InputField } from "../../../../../components/input-field/InputField";
import { WinningPackageAttibutes } from "../../../../../attributes/winning-package-attibutes";
import ICIPAdminService from "../../../../../services/ICIPAdminService";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import IconButton from "@material-ui/core/IconButton";
import { InputSelect } from "../../../../../components/input-select/InputSelect";
import CurrencyService from "../../../../../services/CurrencyService";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modalTitle: {
    fontSize: 20,
    fontWeight: "bold",
  },
  modalBody: {
    width: 416,
    padding: 10,
    border: "none",
  },
  selectInput: {
    marginTop: 30,
  },
  antPickerDropdown: {
    zIndex: 100000,
  },
}));

interface NewWinningPackageProps {
  isOpened: boolean;
  closeCallback: () => void;
  onSubmitCallback: () => void;
}

export const NewWinningPackage = (props: NewWinningPackageProps) => {
  const classes = useStyles();
  const [error, setError] = useState(false);
  const [succeed, setSucceed] = useState(false);
  const intl = useIntl();
  const { formatMessage } = useIntl();
  const { isOpened, closeCallback, onSubmitCallback } = props;
  const [currenciesObjet, setCurrenciesObjet] = useState([]);

  // Formik
  const formik = useFormik({
    initialValues: {
      priority: 0,
      designation_fr: "",
      designation_en: "",
      amount: "",
      wallet_type: "",
    },
    validationSchema: Yup.object().shape({}),
    onSubmit: async (
      values: WinningPackageAttibutes,
      { setSubmitting, resetForm }: FormikHelpers<any>
    ) => {
      try {
        const result = await ICIPAdminService.addWinningPackages(values);
        setSubmitting(false);
        if (result.isSuccess && result.data.code === 100) {
          resetForm({});
          setSucceed(true);
          setTimeout(() => {
            setSucceed(false);
          }, 2000);
          onSubmitCallback();
        } else {
          setError(true);
        }
      } catch (error) {
        setError(true);
      }
      setSubmitting(false);
    },
  });

  const loadCurrenciesList = () => {
    CurrencyService.supportedCurrencies().then((response) => {
      if (response.isSuccess) {
        switch (response.data.code) {
          case 100:
            const currenciesResults = JSON.parse(
              JSON.stringify(response.data.data)
            );
            setCurrenciesObjet(currenciesResults);
            break;
          case 110:
            setError(true);
            console.log(error);
            break;
        }
      } else {
        setError(true);
      }
      //setLoading(false);
    });
  };

  useEffect(() => {
    loadCurrenciesList();
  }, []);

  const handleCurrencyId = (event: any) => {
    formik.values.currency_id = event.target.value;
    // formik.values.code = event.target.code;
  };

  return (
    <Modal className={classes.modal} open={isOpened} onClose={closeCallback}>
      <Paper className={classes.modalBody}>
        <Grid spacing={10} container>
          <Grid item xs={12}>
            <form noValidate autoComplete="off" onSubmit={formik.handleSubmit}>
              <Grid>
                <Grid
                  xs={12}
                  sm={12}
                  lg={12}
                  item
                  container
                  direction="row"
                  justify="space-between"
                  alignItems="center"
                >
                  <Typography variant="h4" component="h4">
                    <FormattedMessage id="sharedScreen.addWinningPackage" />
                  </Typography>
                  <IconButton edge="end" onClick={closeCallback}>
                    <HighlightOffIcon fontSize="large" />
                  </IconButton>
                </Grid>
                <Grid item xs={12} sm={12} lg={12}>
                  <InputField
                    type="number"
                    variant="outlined"
                    size="small"
                    value={formik.values.priority}
                    label={formatMessage({ id: "sharedScreen.priority" })}
                    fullWidth
                    name="priority"
                    onChange={formik.handleChange}
                    error={
                      formik.touched.priority && Boolean(formik.errors.priority)
                    }
                    helperText={
                      formik.touched.priority && formik.errors.priority
                    }
                  ></InputField>
                </Grid>
                <Grid xs={12} sm={12} lg={12}>
                  <InputField
                    fullWidth
                    value={formik.values.designation_fr}
                    label={`${formatMessage({
                      id: "sharedScreen.designationFr",
                    })}`}
                    placeholder={`${formatMessage({
                      id: "sharedScreen.designationFr",
                    })}`}
                    name="designation_fr"
                    onChange={formik.handleChange}
                  />
                </Grid>
                <Grid xs={12} sm={12} lg={12}>
                  <InputField
                    fullWidth
                    value={formik.values.designation_en}
                    label={`${formatMessage({
                      id: "sharedScreen.designationEn",
                    })}`}
                    placeholder={`${formatMessage({
                      id: "sharedScreen.designationEn",
                    })}`}
                    name="designation_en"
                    onChange={formik.handleChange}
                  />
                </Grid>
                <Grid xs={12} sm={6} lg={12}>
                  <InputField
                    type="number"
                    fullWidth
                    label={`${formatMessage({
                      id: "sharedScreen.amount",
                    })}`}
                    placeholder={`${formatMessage({
                      id: "sharedScreen.amount",
                    })}`}
                    name="amount"
                    onChange={formik.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={12} lg={12}>
                  <TextField
                    className={classes.selectInput}
                    select
                    variant="outlined"
                    size="small"
                    value={formik.values.wallet_type}
                    label={formatMessage({
                      id: "sharedScreen.WinningPackageWalletType",
                    })}
                    fullWidth
                    name="wallet_type"
                    onChange={formik.handleChange}
                    error={
                      formik.touched.wallet_type &&
                      Boolean(formik.errors.wallet_type)
                    }
                    helperText={
                      formik.touched.wallet_type && formik.errors.wallet_type
                    }
                  >
                    <MenuItem value="0">
                      {formatMessage({ id: "sharedScreen.pmu" })}
                    </MenuItem>
                    <MenuItem value="1">
                      {formatMessage({ id: "sharedScreen.credit" })}
                    </MenuItem>
                    <MenuItem value="2">
                      {formatMessage({ id: "sharedScreen.fuel" })}
                    </MenuItem>
                    <MenuItem value="3">
                      {formatMessage({ id: "sharedScreen.toll" })}
                    </MenuItem>
                  </TextField>
                </Grid>
                <InputSelect
                  fullWidth
                  id="currency_id"
                  name="currency_id"
                  value={formik.values.currency_id}
                  label={intl.formatMessage({
                    id: "sharedScreen.winningPackageWalletCurrencyId",
                  })}
                  onChange={formik.handleChange}
                  error={
                    Boolean(formik.touched.currency_id) &&
                    Boolean(formik.errors.currency_id)
                  }
                  helperText={
                    formik.touched.currency_id && formik.errors.currency_id
                  }
                >
                  <br />
                  <MenuItem>
                    <FormattedMessage id="sharedScreen.winningPackageWalletCurrencyId" />
                  </MenuItem>
                  {currenciesObjet.map((code, index) => {
                    return <MenuItem value={code.id}>{code.code}</MenuItem>;
                  })}
                </InputSelect>

                <Grid item xs={2} sm={2} lg={1}>
                  <InputButton
                    className={classes.selectInput}
                    disabled={formik.isSubmitting}
                    fullWidth
                    type="submit"
                    variant="contained"
                    color="secondary"
                  >
                    <FormattedMessage id="sharedScreen.save" />
                    {formik.isSubmitting && <CircularProgress size={30} />}
                  </InputButton>
                </Grid>
                {succeed && (
                  <Grid item xs={12} sm={12} lg={12}>
                    <Alert severity="success">
                      <FormattedMessage id="sharedScreen.settingsSavedSuccessfully" />
                    </Alert>
                  </Grid>
                )}
              </Grid>
            </form>
          </Grid>
        </Grid>
      </Paper>
    </Modal>
  );
};
export default NewWinningPackage;
